import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { AppState, useAppSelector } from "../../../store";

const Loader: React.FC = () => {
  const open = useAppSelector((state: AppState) => state.loaderSlice.isLoading);
  return (
    <Backdrop
      className="loaderClass"
      open={open}
      sx={{ zIndex:9999999 }}
    >
      <CircularProgress />
    </Backdrop>
  );
};

export default Loader;
